import {BaseSchema} from "./BaseSchema";

export class HomeSchema extends BaseSchema {

}